import { useEffect, useRef, useState } from "react";
import {
  Wrap,
  Inner,
  Left,
  Eyebrow,
  Title,
  Text,
  Actions,
  Btn,
  Right,
  Slider,
  Slide,
  Img,
  Dots,
  Dot,
  NavBtn,
} from "./GalleryBlockStyles";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useTranslation } from "react-i18next";

export default function GalleryBlock({
  eyebrow = "La Fontanella",
  title = "Astăzi, bucătăria Fontanella®",
  text = "",
  images = [],
  interval = 3000,
  onMenuClick = () => window.open("/meniu_delivery", "_self"),
}) {
  const { t } = useTranslation();
  const [i, setI] = useState(0);
  const len = images.length || 1;
  const tRef = useRef(null);

  useEffect(() => {
    start();
    return stop;
  }, [i, interval, len]);
  const start = () => {
    stop();
    tRef.current = setTimeout(() => setI((v) => (v + 1) % len), interval);
  };
  const stop = () => tRef.current && clearTimeout(tRef.current);
  const prev = () => setI((v) => (v - 1 + len) % len);
  const next = () => setI((v) => (v + 1) % len);

  return (
    <Wrap>
      <Inner>
        <Left>
          <Eyebrow>{eyebrow}</Eyebrow>
          <Title>{title}</Title>
          <Text>{text}</Text>
          <Actions>
            <Btn onClick={onMenuClick}>
              {t("home.gallery.cta")} <span aria-hidden>→</span>
            </Btn>
          </Actions>
        </Left>

        <Right onMouseEnter={stop} onMouseLeave={start}>
          <Slider>
            {images.map((im, idx) => (
              <Slide key={idx} $active={idx === i}>
                <Img src={im.src} alt={im.alt || ""} loading="lazy" />
              </Slide>
            ))}
            {len > 1 && (
              <>
                <NavBtn aria-label="Anterior" onClick={prev} left>
                  <FiChevronLeft />
                </NavBtn>
                <NavBtn aria-label="Următor" onClick={next} right>
                  <FiChevronRight />
                </NavBtn>
              </>
            )}
          </Slider>
          {len > 1 && (
            <Dots>
              {images.map((_, idx) => (
                <Dot key={idx} $active={idx === i} onClick={() => setI(idx)} />
              ))}
            </Dots>
          )}
        </Right>
      </Inner>
    </Wrap>
  );
}
